var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Sprite from 'src/assets/img/symbol/sprite.svg';
import { concatClsx } from 'src/helpers/classNames';
export var IconType;
(function (IconType) {
    IconType["Chat"] = "chat";
    IconType["Back"] = "back";
    IconType["Close"] = "close";
    IconType["FlagOutlined"] = "flag";
    IconType["FlagSolid"] = "flag-2";
    IconType["Menu"] = "menu";
    IconType["Send"] = "send";
    IconType["Send2"] = "send-2";
    IconType["UserOutlined"] = "user-outlined";
    IconType["UserOutlinedLarge"] = "user-outlined-large";
    IconType["UserOutlinedCircle"] = "user-circle";
    IconType["ArrorRight"] = "arrow-right";
    IconType["ArrowLeft"] = "arrow-left";
    IconType["Home"] = "home";
    IconType["HomeSolid"] = "home-solid";
    IconType["Inbox"] = "inbox";
    IconType["InboxSolid"] = "inbox-solid";
    IconType["Leave"] = "leave";
    IconType["Pin"] = "pin";
    IconType["ArrowReply"] = "arrow-reply";
    IconType["CrossCircle"] = "cross-circle";
    IconType["Copy"] = "copy";
    IconType["OopsCharacter"] = "oops-character";
    IconType["NoResultCharacter"] = "no-result-character";
    IconType["Education"] = "education";
    IconType["HeartFilled"] = "heart-filled";
    IconType["GhostSmall"] = "ghost-small";
    IconType["Users"] = "users";
    IconType["UsersSolid"] = "users-solid";
    IconType["UniDefault"] = "uni-default-logo";
    IconType["Stars"] = "stars";
    IconType["TapHome"] = "tap-home";
    IconType["TapUsers"] = "tap-users";
    IconType["TapUser"] = "tap-user";
    IconType["Picture"] = "picture";
    IconType["Help"] = "help";
    IconType["Camera"] = "camera";
    IconType["Messages"] = "messages";
})(IconType || (IconType = {}));
export var Icon = function (_a) {
    var className = _a.className, type = _a.type;
    return (React.createElement("svg", { className: concatClsx("icon icon-".concat(type), className) },
        React.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "".concat(Sprite, "#").concat(type) })));
};
export var IconForAntd = function (props) {
    return (React.createElement("span", { className: "anticon" },
        React.createElement(Icon, __assign({}, props))));
};
